import {ImageRequestParams} from "../../models/image/image-request-params";

export class FacebookImageRequestParams extends ImageRequestParams {
  constructor(width, height, color) {
    super({width, height, color});

    this._resourceName = `bolao24/Icons/Facebook_Icon`;
  }
}
